/*
 * A helper function to init app on fed entrypoint request
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2026 Gallagher Bassett Services, Inc.
 *
 */

import { FedEntrypointService } from "app/shared/services/fed-entrypoint.service";

export function fedInit ( fedEntrypointService: FedEntrypointService ) {
  return async () => {
    // if target url contains fed-auth the authenticate the user and fix the clients
    if ( location.href.includes ( 'fed-auth' ) ) {
      localStorage.removeItem ( 'reporterUser' );
      await fedEntrypointService.authenticateUser ();
    }
    return null;
  };
}
